import { useStyletron } from 'baseui';

export const useCsvUploadPreviewStyles = () => {
	const [css] = useStyletron();

	return {
		css,
		disabledStyle: css({ cursor: 'not-allowed', opacity: 0.75 }),
		containerStyle: css({
			display: 'flex',
			padding: '2px',
			justifyContent: 'flex-start',
			gap: '10px',
			alignItems: 'center',
			minHeight: '44px',
			border: '2px solid rgb(238, 238, 238)',
			backgroundColor: 'rgb(238, 238, 238)'
		}),
		fileNameStyle: css({
			backgroundColor: '#ffffff',
			display: 'flex',
			height: '40px',
			gap: '10px',
			alignItems: 'center',
			padding: '2px'
		}),
		overflowAuto: css({ maxHeight: '400px', overflow: 'auto' }),
		infoText: css({ marginTop: '10px', fontSize: '14px', color: '#666' })
	};
};
